function init() {
    this._construct();

    if (this._playerBehavior) {
        this._playerBehavior.onUpdate = () => {
            if (this._renderBehavior) this._renderBehavior.render();
        };
        this._playerBehavior.init();
    }

    if (this._resizeBehavior) this._resizeBehavior.resize();
    if (this._renderBehavior) this._renderBehavior.render();
    return this;
}

function start() {
    this._addListeners();
    return this;
}

function stop() {
    if (this._playerBehavior) this._playerBehavior.stop();
    this._addListeners(false);
    return this;
}

function destroy() {
    this.stop();
    if (this._playerBehavior) this._playerBehavior.destroy();
    this._playerBehavior = null;
    this._renderBehavior = null;
    this._resizeBehavior = null;
    return this;
}

function play() {
    if (this._playerBehavior) this._playerBehavior.play();
    return this;
}

function playTo(frameOrTime) {
    if (this._playerBehavior) this._playerBehavior.playTo(frameOrTime);
    return this;
}

function gotoAndStop(frameOrTime) {
    if (this._playerBehavior) this._playerBehavior.gotoAndStop(frameOrTime);
    return this;
}

function gotoAndPlay(frameOrTime) {
    if (this._playerBehavior) this._playerBehavior.gotoAndPlay(frameOrTime);
    return this;
}

function playFromTo(frameOrTimeFrom, frameOrTimeTo) {
    if (this._playerBehavior) return this._playerBehavior.playFromTo(frameOrTimeFrom, frameOrTimeTo);
    return this;
}

function tweenFromTo(frameOrTimeFrom, frameOrTimeTo, duration, ease) {
    if (this._playerBehavior) return this._playerBehavior.tweenFromTo(frameOrTimeFrom, frameOrTimeTo, duration, ease);
    return this;
}

function loopFromTo(frameOrTimeFrom, frameOrTimeTo) {
    if (this._playerBehavior) return this._playerBehavior.loopFromTo(frameOrTimeFrom, frameOrTimeTo);
    return this;
}

function waitForLoopComplete(frameOrTimeFrom, frameOrTimeTo) {
    if (this._playerBehavior) return this._playerBehavior.waitForLoopComplete(frameOrTimeFrom, frameOrTimeTo);
    return this;
}

function _handleResize() {
    if (this._resizeBehavior) this._resizeBehavior.resize();
    if (this._renderBehavior) this._renderBehavior.render();
}

function _addListeners(b) {
    if (b === false) {
        window.removeEventListener('resize', this._handleResize);
        return;
    }
    window.addEventListener('resize', this._handleResize);
}

module.exports = construct => {
    const Anim = {};

    Anim._construct = function() {
        return construct(this);
    }.bind(Anim);

    Anim.init = init.bind(Anim);
    Anim.start = start.bind(Anim);
    Anim.stop = stop.bind(Anim);
    Anim.play = play.bind(Anim);
    Anim.gotoAndStop = gotoAndStop.bind(Anim);
    Anim.gotoAndPlay = gotoAndPlay.bind(Anim);
    Anim.playTo = playTo.bind(Anim);
    Anim.playFromTo = playFromTo.bind(Anim);
    Anim.tweenFromTo = tweenFromTo.bind(Anim);
    Anim.loopFromTo = loopFromTo.bind(Anim);
    Anim.waitForLoopComplete = waitForLoopComplete.bind(Anim);
    Anim.destroy = destroy.bind(Anim);
    Anim._addListeners = _addListeners.bind(Anim);
    Anim._handleResize = _handleResize.bind(Anim);

    return Anim;
};
